module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form-horizontal">\n    <div>\n        <div class="form-group">\n            <label class="col-xs-2 col-md-2 control-label" for="id-npi">NPI</label>\n            <div class="col-xs-10 col-md-10">\n                <input class="form-control" type="text" id="id-npi" placeholder="NPI" value="'+
((__t=( object.npi ))==null?'':_.escape(__t))+
'">\n            </div>\n            <div class="col-xs-2 col-md-2">\n                <label id="progress"><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>\n                    Request...</label>\n            </div>\n            <div class="col-xs-2 col-md-2">\n                <button type="button" class="btn btn-primary" id="re-request">Re-request</button>\n            </div>\n            <div class="col-xs-2 col-md-2">\n                <button type="button" class="btn btn-primary" id="fill-form">Fill form</button>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-2 col-md-2 control-label" for="id-name">Name</label>\n            <div class="col-xs-10 col-md-10">\n                <input class="form-control" type="text" id="id-name" placeholder="Organization name"\n                       value="'+
((__t=( name ))==null?'':_.escape(__t))+
'">\n            </div>\n        </div>\n        ';
 if (!isEditMode) { 
__p+='\n        <div class="form-group">\n            <label class="col-xs-2 col-md-2 control-label">Address</label>\n            <div class="col-xs-3 col-md-3">\n                <input class="form-control address-field" type="text" id="town" placeholder="Town" required=""/>\n            </div>\n            <div class="col-xs-4 col-md-4">\n                <div id="state-select"></div>\n            </div>\n            <div class="col-xs-3 col-md-3">\n                <input class="form-control address-field" type="text" id="zip" placeholder="Zip code" required=""/>\n            </div>\n        </div>\n        <div class="form-group">\n            <div class="col-md-offset-2 col-xs-offset-2 col-xs-10 col-md-10">\n                <input class="form-control address-field" type="text" id="address" placeholder="Address line" required=""/>\n            </div>\n        </div>\n        ';
 } 
__p+='\n\n        <div class="form-group">\n            <label class="col-xs-2 col-md-2 control-label" for="creation-date">Creation date</label>\n            <div class="col-xs-10 col-md-10">\n                <input class="form-control" type="text" id="creation-date" placeholder="Creation date"\n                       value="'+
((__t=( created ))==null?'':_.escape(__t))+
'">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-2 col-md-2 control-label">Review period</label>\n            <label class="col-xs-1 col-md-1 control-label" for="review-period-days">Days</label>\n            <div class="col-xs-2 col-md-2">\n                <select id="review-period-days">\n                    ';
 _.each(days, function(day){ 
__p+='\n                    ';
 if (object.defaultReviewPeriod && object.defaultReviewPeriod.days && object.defaultReviewPeriod.days === day) { 
__p+='\n                    <option value="'+
((__t=( day ))==null?'':__t)+
'" name="'+
((__t=( day ))==null?'':__t)+
'" selected> '+
((__t=( day ))==null?'':__t)+
'</option>\n                    ';
 } else if (day === 3 && !object.defaultReviewPeriod) { 
__p+='\n                    <option value="'+
((__t=( day ))==null?'':__t)+
'" name="'+
((__t=( day ))==null?'':__t)+
'" selected> '+
((__t=( day ))==null?'':__t)+
'</option>\n                    ';
 } else { 
__p+='\n                    <option value="'+
((__t=( day ))==null?'':__t)+
'" name="'+
((__t=( day ))==null?'':__t)+
'"> '+
((__t=( day ))==null?'':__t)+
'</option>\n                    ';
 } 
__p+='\n                    ';
 }) 
__p+='\n                </select>\n            </div>\n            <label class="col-xs-1 col-md-1 control-label" for="review-period-hours">Hours</label>\n            <div class="col-xs-2 col-md-2">\n                <select id="review-period-hours">\n                    ';
 _.each(hours, function(hour){ 
__p+='\n                    ';
 if (object.defaultReviewPeriod && object.defaultReviewPeriod.hours && object.defaultReviewPeriod.hours === hour) { 
__p+='\n                    <option value="'+
((__t=( hour ))==null?'':__t)+
'" name="'+
((__t=( hour ))==null?'':__t)+
'" selected> '+
((__t=( hour ))==null?'':__t)+
'</option>\n                    ';
 } else if (hour === 0) { 
__p+='\n                    <option value="'+
((__t=( hour ))==null?'':__t)+
'" name="'+
((__t=( hour ))==null?'':__t)+
'" selected> '+
((__t=( hour ))==null?'':__t)+
'</option>\n                    ';
 } else { 
__p+='\n                    <option value="'+
((__t=( hour ))==null?'':__t)+
'" name="'+
((__t=( hour ))==null?'':__t)+
'"> '+
((__t=( hour ))==null?'':__t)+
'</option>\n                    ';
 } 
__p+='\n                    ';
 }) 
__p+='\n                </select>\n            </div>\n        </div>\n    </div>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/organizations/organization-form.html
// module id = 217
// module chunks = 0